function padLeft (nr, n, str) {
  return Array(n - String(nr).length + 1).join(str || '0') + nr
}

const methods = {
  isEmptyArray: (value) => {
    console.log(value)
    for (let i = 0; i < value.length; i++) {
      if (value[i] === '' || value[i] === null || value[i] === undefined) {
        return true
      }
    }
    return false
  },
  buildAudioPath (contentCode, index) {
    //SPL01B01U01L010
    const course = contentCode.substring(0, 2)
    const level = contentCode.substring(2, 5)
    const book = contentCode.substring(5, 8)
    const unit = contentCode.substring(8, 11)
    const menu = contentCode.substring(11, 14)
    const fileIndex = padLeft(index, 2)
    const contentPath = `${process.env.VUE_APP_CONTENT_URL}${course}/${level}/${book}/${unit}/${menu}/${contentCode}_${fileIndex}.mp3`
    return contentPath
  },
  buildCheckUpAudioPath (contentCode, fileName) {
    const course = contentCode.substring(0, 2)
    const level = contentCode.substring(2, 5)
    const book = contentCode.substring(5, 8)
    const unit = contentCode.substring(8, 11)
    const menu = contentCode.substring(11, 14)
    const contentPath = `${process.env.VUE_APP_CONTENT_URL}${course}/${level}/${book}/${unit}/${menu}/${fileName}`
    return contentPath
  },
  buildVideoPath (contentCode) {
    //GRL01B01U01G010.mp4
    const course = contentCode.substring(0, 2)
    const level = contentCode.substring(2, 5)
    const book = contentCode.substring(5, 8)
    const unit = contentCode.substring(8, 11)
    const menu = contentCode.substring(11, 14)
    const contentPath = `${process.env.VUE_APP_CONTENT_URL}${course}/${level}/${book}/${unit}/${menu}/${contentCode}.mp4`
    return contentPath
  },
  buildImagePath (contentCode, index) {
    //PHL01B01U01P05001.jpg
    const course = contentCode.substring(0, 2)
    const level = contentCode.substring(2, 5)
    const book = contentCode.substring(5, 8)
    const unit = contentCode.substring(8, 11)
    const menu = contentCode.substring(11, 14)
    const fileIndex = padLeft(index, 2)
    const contentPath = `${process.env.VUE_APP_CONTENT_URL}${course}/${level}/${book}/${unit}/${menu}/${contentCode}${fileIndex}.jpg`
    return contentPath
  },
  buildPHImagePath (contentCode, index, imageIndex) {
    //PHL01B01U01P05001.jpg
    const course = contentCode.substring(0, 2)
    const level = contentCode.substring(2, 5)
    const book = contentCode.substring(5, 8)
    const unit = contentCode.substring(8, 11)
    const menu = contentCode.substring(11, 14)
    const contentPath = `${process.env.VUE_APP_CONTENT_URL}${course}/${level}/${book}/${unit}/${menu}/${contentCode}${index}${imageIndex}.jpg`
    return contentPath
  },
  buildPFAudioPath (contentCode, index, number) {
    //SPL01B01U01L010
    const course = contentCode.substring(0, 2)
    const level = contentCode.substring(2, 5)
    const book = contentCode.substring(5, 8)
    const unit = contentCode.substring(8, 11)
    const menu = contentCode.substring(11, 14)
    const sentenceIndex = padLeft(index, 2)
    const fileIndex = padLeft(number, 2)
    const contentPath = `${process.env.VUE_APP_CONTENT_URL}${course}/${level}/${book}/${unit}/${menu}/${contentCode}${sentenceIndex}_${fileIndex}.mp3`
    return contentPath
  },
  displayUnitName (unit) {
    if (unit === null || unit === undefined) return
    return unit.replace('U', 'Unit ')
  }
}

export default {
  install (Vue) {
    Vue.prototype.$isEmptyArray = methods.isEmptyArray
    Vue.prototype.$buildAudioPath = methods.buildAudioPath
    Vue.prototype.$buildImagePath = methods.buildImagePath
    Vue.prototype.$buildPHImagePath = methods.buildPHImagePath
    Vue.prototype.$buildPFAudioPath = methods.buildPFAudioPath
    Vue.prototype.$buildVideoPath = methods.buildVideoPath
    Vue.prototype.$displayUnitName = methods.displayUnitName
    Vue.prototype.$buildCheckUpAudioPath = methods.buildCheckUpAudioPath
  }
}